<template>
    <div class="modal fade fill-in disable-scroll" id="modal" tabindex="-1" role="dialog" aria-hidden="false"
        style="z-index: 9999" data-backdrop="static">
        <div class="modal-dialog modal-confirm modal-lebar modal-md mt-3">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="card shade">
                        <div class="card-header d-flex">
                            <h3>Ekspor Filter</h3>
                            <div class="shade ml-auto clickable hoverable bg-white"
                                style=" margin-right: -30px; margin-top: -25px; height: 2rem; width: 2rem; display: flex; justify-content: center; align-items: center;"
                                data-dismiss="modal" data-backdrop="false" @click="closeModal">
                                <i class="bi bi-x" style="font-size: 30px"></i>
                            </div>
                        </div>
                        <form action="#" id="post-filter-modal-ekspor" v-on:submit.prevent="submitForm">
                            <div class="card-body mt-3">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-check complete col-12">
                                            <input type="checkbox" id="checkAll_medsos" v-model="allChecked_medsos" />
                                            <label for="checkAll_medsos" class="h5">Filter Media Sosial</label>
                                        </div>
                                        <div v-for="(field_medsos, index_medsos) in fields_list" :key="index_medsos"
                                            class="form-check complete col-12">
                                            <input type="checkbox" :id="'check_medsos-' + index_medsos"
                                                v-model="field_medsos.isChecked" />
                                            <label :for="'check_medsos-' + index_medsos"> {{ field_medsos.name }}</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-check complete col-12">
                                            <input type="checkbox" id="checkAll_medkon" v-model="allChecked_medkon" />
                                            <label for="checkAll_medkon" class="h5">
                                                Filter Media Online</label>
                                        </div>
                                        <div v-for="(field_medkon, index_medkon) in fields_list_medkon" :key="index_medkon"
                                            class="form-check complete col-12">
                                            <input type="checkbox" :id="'check_medkon-' + index_medkon"
                                                v-model="field_medkon.isChecked" :disabled="field_medkon.isDisabled" />
                                            <label :for="'check_medkon-' + index_medkon"> {{ field_medkon.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group card-footer" align="right">
                                <button type="submit" class="btn btn-warning">Simpan</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import moment from "moment";
import $ from "jquery";

export default {
    name: "modal_ekspor",
    components: {},
    data() {
        return {
            fields_list: [],
            fields_list_medkon: [],
            allChecked_medsos: true,
            selectedValues_medsos: [],
            allChecked_medkon: true,
            selectedValues_medkon: [],
            id_project: this.$store.getters.user.id_project,
        };
    },
    methods: {
        closeModal: function () {
            this.$parent.modal_ekspor = false;
        },
        cancelSearch: function () {
            this.$parent.modal_ekspor = false;
            $("#modal").modal("hide");
        },
        checkAll_medsos() {
            this.selectedValues_medsos = this.fields_list.map(
                (option) => option.id
            );
        },
        checkNone_medsos() {
            this.selectedValues_medsos = [];
        },
        checkAll_medkon() {
            this.selectedValues_medkon = this.fields_list_medkon.map(
                (option) => option.id
            );
        },
        checkNone_medkon() {
            this.selectedValues_medkon = [];
        },
        submitForm: function () {
            let api = process.env.VUE_APP_API_URL;
            let api_project = api + "project-detail/" + this.id_project;
            let nama_proyek;
            let nama_file;
            this.$http.get(api_project).then((response) => {
                if (response.status == 200) {
                    let fulldate = moment().format("YYYYMMDHHmmss");
                    nama_proyek = response.data.project_detail.name;
                    nama_file =
                        "MediaForensics-" + nama_proyek + "-" + fulldate + ".xlsx";
                    var params = this.$route.query;

                    if ("page" in params) {
                        delete params.page;
                    }

                    if ("q" in params) {
                        params.q = btoa(params.q);
                    }

                    params.time = fulldate;

                    let medsos_filter = this.fields_list.filter(function (obj) {
                        return obj.isChecked;
                    }).map(function (obj) { return obj.id; });

                    let medsos = this.$sanitize(medsos_filter);
                    params.medsos = btoa(medsos);

                    let medkon_filter = this.fields_list_medkon.filter(function (obj) {
                        return obj.isChecked;
                    }).map(function (obj) { return obj.id; });

                    let medkon = this.$sanitize(medkon_filter);
                    params.medkon = btoa(medkon);

                    let query = Object.keys(params)
                        .map((key) => key + "=" + params[key])
                        .join("&");

                    let url_api =
                        process.env.VUE_APP_API_URL +
                        "new-export/" +
                        this.id_project +
                        "?" +
                        query;

                    const link = document.createElement("a");
                    link.href = url_api;
                    link.target = "_blank";
                    link.setAttribute("download", nama_file);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            });
        },
    },
    mounted: function () {
        $("#modal").modal("show");
    },
    created: function () {
        this.fields_list = [
            {
                id: "medsos_tanggal",
                name: "Tanggal & Jam",
                isChecked: false,
            },
            {
                id: "medsos_akun_judul",
                name: "Akun/Judul",
                isChecked: true,
            },
            {
                id: "medsos_konten",
                name: "Konten",
                isChecked: false,
            },
            {
                id: "medsos_sentimen",
                name: "Sentimen",
                isChecked: false,
            },
            {
                id: "medsos_emotion",
                name: "Emotion",
                isChecked: false,
            },
            {
                id: "medsos_sumber",
                name: "Sumber",
                isChecked: true,
            },
            {
                id: "medsos_url",
                name: "URL",
                isChecked: false,
            },
            {
                id: "medsos_followers",
                name: "Followers",
                isChecked: false,
            },
            {
                id: "medsos_likes",
                name: "Likes",
                isChecked: false,
            },
            {
                id: "medsos_retweets",
                name: "Retweets",
                isChecked: false,
            },
            {
                id: "medsos_esmr",
                name: "Reach",
                isChecked: false,
            },
            {
                id: "medsos_view",
                name: "View",
                isChecked: false,
            },
            {
                id: "medsos_engagement",
                name: "Engagement",
                isChecked: false,
            },
            {
                id: "medsos_location",
                name: "Lokasi",
                isChecked: false,
            },
            {
                id: "medsos_jenis_akun",
                name: "Jenis Akun",
                isChecked: false,
            },
            {
                id: "medsos_jenis_unggahan",
                name: "Jenis Unggahan",
                isChecked: false,
            },
            {
                id: "medsos_is_validated",
                name: "Is Validated",
                isChecked: false,
            },
            {
                id: "medsos_hoax",
                name: "Hoaks",
                isChecked: false,
            },
            {
                id: "medsos_botscore",
                name: "Bot Score",
                isChecked: false,
            },
        ];

        this.fields_list_medkon = [
            {
                id: "medkon_tanggal",
                name: "Tanggal",
                isChecked: false,
            },
            {
                id: "medkon_akun",
                name: "Akun/Judul",
                isChecked: true,
            },
            {
                id: "medkon_konten",
                name: "Konten",
                isChecked: false,
            },
            {
                id: "medkon_sentimen",
                name: "Sentimen",
                isChecked: false,
            },
            {
                id: "medkon_emotion",
                name: "Emotion",
                isChecked: false,
            },
            {
                id: "medkon_sumber",
                name: "Sumber",
                isChecked: true,
            },
            {
                id: "medkon_url",
                name: "URL",
                isChecked: false,
            },
            {
                id: "medkon_jurnalis",
                name: "Jurnalis",
                isChecked: false,
            },
            {
                id: "medkon_narasumber",
                name: "Narasumber",
                isChecked: false,
            },
            {
                id: "medkon_ad_value",
                name: "AD",
                isChecked: false,
            },
            {
                id: "medkon_pr_value",
                name: "PR",
                isChecked: false,
            },
            {
                id: "medkon_halaman",
                name: "Halaman",
                isChecked: false,
            },
            {
                id: "medkon_jenis_akun ",
                name: "Jenis Akun",
                isChecked: false,
            },
            {
                id: "medkon_location",
                name: "Location",
                isChecked: false,
            },
            {
                id: "medkon_amec",
                name: "AMEC",
                isChecked: false,
            },
            {
                id: "medkon_tier_media ",
                name: "Tier Media",
                isChecked: false,
            },
            {
                id: "medkon_is_validated",
                name: "Is Validated",
                isChecked: false,
            },
            // {
            //     id: "medkon_link_internal",
            //     name: "Link Internal",
            //     isChecked: false,
            // },
            {
                id: "medkon_hoax",
                name: "Hoaks",
                isChecked: false,
            },

        ];
    },
    computed: {
        isAllChecked_medsos() {
            return false;
        },
        isAllChecked_medkon() {
            return false;
        },
    },
    watch: {
        allChecked_medsos() {
            this.fields_list.forEach((element) => { element.isChecked = this.allChecked_medsos; }
            )
        },
        allChecked_medkon() {
            this.fields_list_medkon.forEach((element) => { element.isChecked = this.allChecked_medkon; }
            )
        },
    }
};
</script>
  
<style scoped>
.modal.fade.fill-in>.close>i {
    font-size: 60px;
}

.modal-lebar {
    /* width: 100% !important; */
    max-width: 800px;

}
</style>
  